module.exports = __webpack_public_path__ + "static/media/11.1d57d34b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/11.png
// module id = 1116
// module chunks = 0